// extracted by mini-css-extract-plugin
export default {"pageRoot":"LandingPage_pageRoot__JuwIM","loaderSection":"LandingPage_loaderSection__ypJn3","loader":"LandingPage_loader__OnavO","spin":"LandingPage_spin__SeX2n"};